// extracted by mini-css-extract-plugin
export default {"options_parent":"SearchBar_options_parent__C9D3p","options_box":"SearchBar_options_box__Goam0"};